/**
 * Catálogo de posiciones de fútbol
 * Mapea los nombres completos de posiciones a sus abreviaciones
 */

export const positionCatalog = {
  "Portero": "POR",
  "Defensa Central": "DC",
  "Defensa": "DEF",
  "Lateral Izquierdo": "LI",
  "Lateral Derecho": "LD",
  "Centrocampista": "CC",
  "Centrocampista Defensivo": "CD",
  "Centrocampista Ofensivo": "CO",
  "Medio": "MED",
  "Extremo Izquierdo": "EI",
  "Extremo Derecho": "ED",
  "Delantero": "DEL",
  "Delantero Centro": "DC",
  "Segunda Punta": "SP",
  "Pivot": "PIV",
  // Variantes en inglés
  "Goalkeeper": "POR",
  "Center Back": "DC",
  "Defender": "DEF",
  "Left Back": "LI",
  "Right Back": "LD",
  "Midfielder": "CC",
  "Defensive Midfielder": "CD",
  "Offensive Midfielder": "CO",
  "Attacking Midfielder": "MP",
  "Left Winger": "EI",
  "Right Winger": "ED",
  "Striker": "DEL",
  "Forward": "DEL",
};

/**
 * Obtiene la abreviación de una posición
 * @param {string} positionLabel - El nombre completo de la posición
 * @returns {string} La abreviación o el nombre original si no existe en el catálogo
 */
export const getPositionAbbreviation = (positionLabel) => {
  if (!positionLabel) return "-";
  return positionCatalog[positionLabel] || positionLabel;
};
